import React from 'react';
import MediaQuery from 'react-responsive';
import './Experience.css';

import Button from '../../../components/UI/Button/Button';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textarea from '../../../components/UI/Textarea/Textarea';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Checkbox from '../../../components/UI/Checkbox/Checkbox';
import MonthPicker from '../../../components/UI/MonthPicker/MonthPicker';
import Aux from '../../../hoc/Auxi/Auxi';
import moment from 'moment';
// import calendarIcon from '../../../assets/images/calendar-grey.svg';
import { checkValidity } from '../../../shared/utility';
// import Icon from '../../UI/Icon/Icon';
import dropdownGreyIcon from '../../../assets/images/dropdown-arrow-grey.svg';
// import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

const PresentDate = (props) => (
  <div className="date-end-present">
    <label>{props.label}</label>
    <div class="date-end-present-wrapper">
      <div class="date-end-present-icon">
        <img src={dropdownGreyIcon} alt="drop down icon"/>
      </div>
      <div class="date-end-present-content">
        <input readOnly={true} value="Present"/>
      </div>
    </div>
  </div>
);

/**
* @desc Experience in candidate profile section
* @param props
* @return DOM element
*/
const Experience = (props) => {
  const inValid = (props.expErrorFieldIndex.includes(props.index));  
  const blurValid =  props.fieldPosition === props.index;
  const blurId = props.blurId;
  const imProperStartDate = ((inValid || blurValid) && moment(new Date(props.dateEnd))._isValid && (props.current_role === '0' && props.dateStart > props.dateEnd || (props.current_role === '1' && checkValidity(props.dateStart,'isFutureDate'))));
  const imProperEndDate = ((inValid || blurValid) && props.dateStart > props.dateEnd);
  const inVaildStartDate = ((inValid || blurValid) && !moment(new Date(props.dateStart))._isValid);
  const inVaildEndDate = ((inValid || blurValid) && !moment(new Date(props.dateEnd))._isValid);
  let errorTitle = "";let errorCompany = ""; let errorDescription = "";
  if((inValid && props.title.trim() === "") || (blurValid && props.title.trim() === "" && blurId === 'title')){
    errorTitle =  "Please Provide a valid Job Title";
  }
  if((inValid && props.company.trim() === "" ) || (blurValid && props.company.trim() === "" && blurId === 'company')){
    errorCompany =  "Please Provide a valid Company Name";
  }
  if((inValid && props.description.trim() === "" ) || (blurValid && props.description.trim() === "" && blurId === 'description')){
    errorDescription =  "Please enter candidates work experience to continue";
  }

  return (
    <div className="profile-edit__item">
      <FormGrid grid="auto auto">
        <h2 className="profile-edit__item_h2">Role {props.index+1}<Button size="small" className="profile-edit__remove-button" onClick={(event) => props.removeExperience(event, props.index)}>Remove</Button></h2>
        <div className="profile-edit__current-role">
          <Checkbox id="current_role" 
            label="Current Role" 
            checked={(props.current_role === '1') ? true : false} 
            onClick={(event) => props.handleCurrentRole(props.current_role, props.index,event)} />
        </div>
      </FormGrid>
      <FormGrid>
        <Textbox id="title" 
          label="Job Title" 
          placeholder="" 
          value={props.title} 
          onChange={(event) => props.handleExperienceChange(event, props.index)}
          onBlur={(event)=>props.handleOnBlurExperience(event,props.index)} 
          inValid={((blurValid && props.title.trim() === "" && blurId === 'title') || (inValid && props.title.trim() === "")) ? "Invalid" : "" }>          
          {errorTitle}
        </Textbox>
      </FormGrid>
      <FormGrid>
        <Textbox id="company" 
          label="Company" 
          onBlur={(event)=>props.handleOnBlurExperience(event,props.index)}  
          placeholder="" value={props.company} 
          onChange={(event) => props.handleExperienceChange(event, props.index)} 
          inValid={((blurValid && props.company.trim() === "" && blurId === 'company' ) || (inValid && props.company.trim() === "")) ?"Invalid":""}>
          {errorCompany}
        </Textbox>
      </FormGrid>
      
      <MediaQuery query="(min-device-width: 768px)">
        <FormGrid grid="auto auto 135px">
          <div>
            <MonthPicker 
              id="dateStart" 
              label="From" 
              value={props.dateStart.slice(0, 10)}  
              fieldName='dateStart'
              fieldIndex={props.index}
              onBlur={(event)=>props.handleOnBlurExperience(event,props.index)} 
              handleDateChange={props.handleExperienceDateChange}
              className={((inValid || (blurValid && blurId === "dateStart")) && (inVaildStartDate || imProperStartDate)) ?"Invalid":""}
              error={((inValid || (blurValid && blurId === "dateStart")) && inVaildStartDate) ?"From Date must be included": ((inValid || (blurValid && blurId === "dateStart")) && imProperStartDate) ? "From date must be before To date" : null}
              dateStart={null}
              dateEnd={props.dateEnd?props.dateEnd:null}
              presentJob={props.current_role === '1'?true:false}
            />
          </div>
          <div>
            {(props.current_role === '1') ? 
              <PresentDate id="dateEnd" label="To" /> 
              : <MonthPicker 
                  id="dateEnd" 
                  label="To" 
                  value={props.dateEnd.slice(0, 10)} 
                  fieldName='dateEnd'
                  fieldIndex={props.index}
                  onBlur={(event)=>props.handleOnBlurExperience(event,props.index)} 
                  handleDateChange={props.handleExperienceDateChange}
                  className={((inValid || (blurValid && blurId === "dateEnd")) && (inVaildEndDate || imProperEndDate)) ? "Invalid":""}
                  error={((inValid || (blurValid && blurId === "dateEnd")) && inVaildEndDate) ? "To Date must be included": ((inValid || (blurValid && blurId === "dateEnd")) && imProperEndDate) ? "From date must be before To date" : null}
                  currentRole={props.current_role}
                  dateStart={props.dateStart?props.dateStart:null}
                  dateEnd={null}
                  presentJob={false}
                />
            }
          </div>
        </FormGrid>
      </MediaQuery>
      
      <MediaQuery query="(max-device-width: 767px)">
        <FormGrid grid="auto auto" gap="22px">
          <div>
            <MonthPicker id="dateStart" 
              label="From" 
              value={props.dateStart.slice(0, 10)} 
              fieldName='dateStart'
              fieldIndex={props.index}
              handleDateChange={props.handleExperienceDateChange}
              className={((inValid || (blurValid && blurId === "dateStart")) && (inVaildStartDate || imProperStartDate)) ? "Invalid":""}
              error={((inValid || (blurValid && blurId === "dateStart")) && inVaildStartDate) ?"From Date must be included": ((inValid || (blurValid && blurId === "dateStart")) && imProperStartDate) ? "From date must be before To date" : null}
              dateStart={null}
              dateEnd={props.dateEnd?props.dateEnd:null}
              presentJob={props.current_role === '1'?true:false}
            />
          </div>
          <div>
            {(props.current_role === '1') ? 
              <PresentDate id="dateEnd" label="To" /> 
              : <MonthPicker 
                id="dateEnd" label="To" 
                value={props.dateEnd.slice(0, 10)} 
                fieldName='dateEnd'
                fieldIndex={props.index}
                onBlur={(event)=>props.handleOnBlurExperience(event,props.index)} 
                handleDateChange={props.handleExperienceDateChange}
                className={((inValid || (blurValid && blurId === "dateEnd")) && (inVaildEndDate || imProperEndDate)) ? "Invalid":""}
                error={((inValid || (blurValid && blurId === "dateEnd")) && inVaildEndDate) ? "To Date must be included": ((inValid || (blurValid && blurId === "dateEnd")) && imProperEndDate) ? "From date must be before To date" : null}
                currentRole={props.current_role}
                dateStart={props.dateStart?props.dateStart:null}
                dateEnd={null}
                presentJob={false}
              />

            }
          </div>
        </FormGrid>
      </MediaQuery>
      
      <FormGrid>
        <Textarea 
          id="description" 
          label="Description"  
          onChange = {(event) => {props.handleExperienceChange(event, props.index)}}
          onBlur={(event)=>props.handleOnBlurExperience(event,props.index)} 
          inValid={((blurValid && props.description.trim() === "" && blurId === 'description' ) || (inValid && props.description.trim() ==="")) ?"Invalid":""}
          errorMsg = {errorDescription}
          value={props.description}
        />
      </FormGrid>
    </div>
  )
}


/**
* @desc Experiences in candidate profile section
* @param props
* @return DOM element
*/
const Experiences = (props) => {
  const updateText = props.experActive ==="updated" ? "Updated" : "Update";
  const disabled = props.experActive ==="update" ? 'disabled' : "";
  return (
    <Aux>
      {props.candidate.experience.map((exp, index) => (
        <Experience 
          key={index} 
          index={index}  
          {...exp} 
          handleExperienceChange={props.handleExperienceChange} 
          handleExperienceDateChange={props.handleExperienceDateChange}
          handleCurrentRole={props.handleCurrentRole}
          expErrorFieldIndex={props.expErrorFieldIndex}
          removeExperience={props.removeExperience}
          blurId = {props.blurId}
          fieldPosition = {props.fieldPosition}
          isCurrentRole={(exp.current_role === '1') ? true : false}
          handleOnBlurExperience={props.handleOnBlurExperience}
        />
      ))}
      <div className="profile-edit__section__buttons">
        <MediaQuery query="(min-device-width: 768px)">
          <Button 
            uistyle="secondary" 
            className="profile-edit__add-button" 
            onClick={props.addExperience}
          >+ Add Experience</Button>
      </MediaQuery> 
        <Button className={props.experActive} disabled={disabled} onClick={(event) => props.handleUpdateProfile(event, 'experActive')}>{updateText}</Button>
      </div>
    </Aux>
  );
}

export default Experiences;



// WEBPACK FOOTER //
// ./src/components/Recruiter/Experience/Experience.js